// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__17KHR","alert":"SettungsInbox_alert__3o9M8"};